import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, OnChanges, HostListener, Host } from '@angular/core';
import moment from 'moment';
import { GlobalConstants } from './../../../meeting-manager/lib/global-constants';
import { ViewMeetingComponent } from '../../../meeting-manager/lib/popup/view-meeting/view-meeting.component';
import { DataService } from '../../../core/services/data.service';
import { MeetingMapping } from '../../../meeting-manager/lib/mapping/meeting-mapping';
import { MeetingScheduler } from '../../../meeting-manager/lib/models/meeting-dragdrop.model';
import { Constants } from '../../../meeting-manager/lib/constants';
import { CommonService } from '../../../meeting-manager/lib/services/common.service';
import { SnackbarService } from '../../../meeting-manager/lib/services/snackbar.service';
import { MeetingManagerService } from '../../../meeting-manager/lib/services/meeting-manager.service';
import { Subscription } from 'rxjs';
import { DialogService } from '@tylertech/forge-angular';
import { SchedularDetailsModel } from 'app/meeting-manager/lib/models/meeting-manager.model';
import { options } from '@fullcalendar/core/preact';

@Component({
  selector: 'appc-schedular-list-view',
  providers: [GlobalConstants, MeetingMapping, Constants, CommonService],
  templateUrl: './schedular-list-view.component.html',
  styleUrls: ['./schedular-list-view.component.scss'],
  standalone: false,
})
export class SchedularListViewComponent implements OnInit, OnDestroy,  OnChanges {

  meetings: Array<MeetingScheduler> = [];
  listSchedulerEvents: any;
  onLoadScroll: Boolean = false;
  isEventSingleClick: Boolean = true;

  @Input() schedularDetails = new SchedularDetailsModel();

  private subscriptions: Subscription;

  constructor(private globalConstants: GlobalConstants,
    private dialogService: DialogService,
    public meetingManagerService: MeetingManagerService,
    public snackbarService: SnackbarService,
    public dataService: DataService,
    private meetingMapping: MeetingMapping,
    private constants: Constants) {
    this.meetingManagerService.setSelectedTime(null);
    this.onLoadScroll = true;
  }

  /**
   *Get Meeting for the list view.
   *
   * @memberof SchedularListViewComponent
   */
  getMeeting() {
    const dateFormat = this.globalConstants.format.date;
    const startDate = this.schedularDetails.isMobileMode ? this.schedularDetails.startDate
      : moment(this.schedularDetails.selectedDate).startOf('month').format(dateFormat);
    const endDate = this.schedularDetails.isMobileMode ? this.schedularDetails.endDate
      : moment(this.schedularDetails.selectedDate).endOf('month').format(dateFormat);
    const params = { startDate: startDate, endDate: endDate, meetingTypeIds: this.schedularDetails.meetingTypeIds };
    const url = this.globalConstants.baseUrl + this.constants.serviceUrl.meeting.getMeetingByDateRange;

    this.subscriptions = this.dataService.post(url, params).subscribe((res: any) => {
      this.meetings = this.meetingMapping.setMeetingScheduler(res).slice(0);
      this.prepareListScheduler();
    }, (error: any) => {
      console.log(error);
      this.snackbarService.showMessage(this.constants.messages.error.internalServerError);

      this.prepareListScheduler();
    });

  }

  /**
   *Fetching Days for the Month
   *
   * @param {*} date
   * @returns
   * @memberof SchedularListViewComponent
   */
  getDaysByMonth(date: any) {
    let daysInMonth = moment(date).daysInMonth();
    const arrDays = [];

    while (daysInMonth) {
      const current = moment(date).date(daysInMonth);
      arrDays.push(current);
      daysInMonth--;
    }
    return arrDays;
  }

  /**
   *Fetching Days for a Date Range (for mobile custom date selection)
   *
   * @param {string} startDate
   * @param {string} endDate
   * @returns
   * @memberof SchedularListViewComponent
   */
  getDaysByDateRange(startDate: string, endDate: string) {
    const arrDays = [];
    const start = moment(startDate, this.globalConstants.format.date);
    const end = moment(endDate, this.globalConstants.format.date);

    let currentDate = start.clone();
    while (currentDate.isSameOrBefore(end)) {
      arrDays.push(currentDate.clone());
      currentDate.add(1, 'days');
    }

    return arrDays;
  }


  /**
   *Single Click
   *
   * @param {*} event
   * @memberof SchedularListViewComponent
   */
  schedulerEventClicked(event: any) {
    this.isEventSingleClick = true;
    setTimeout(() => {
      if (this.isEventSingleClick) {
        this.openViewDetailsDialog(event);
      }
    }, 250);
  }
  
  /**
   * Opening the View Detail Dialog
   *
   * @param {*} meeting
   * @memberof SchedularListViewComponent
   */
  openViewDetailsDialog(meeting: any): void {
    const dialogRef = this.dialogService.open(
      ViewMeetingComponent,
      {
        data: {
          meetingId: meeting.data.id,
          recurringId: meeting.data.recurringId,
          backgroundColor: meeting.borderColor,
        },
        options: this.constants.setDialogOptions(
          false,
          this.constants.forgeDialog.dialogClass
        )
      }
    );
    dialogRef.afterClosed.subscribe(() => {
      this.prepareListScheduler();
    });
  }
  /**
   *Preparing list schedular i.e. meeting
   *
   * @memberof SchedularListViewComponent
   */
  prepareListScheduler(): void {
    if (this.meetings && this.meetings.length > 0) {
      this.listSchedulerEvents = [];
      // If mobile mode with custom date range, use date range; otherwise use single month
      const resultList = (this.schedularDetails.isMobileMode &&
                          this.schedularDetails.startDate &&
                          this.schedularDetails.endDate)
        ? this.getDaysByDateRange(this.schedularDetails.startDate, this.schedularDetails.endDate)
        : this.getDaysByMonth(moment(this.schedularDetails.selectedDate));
      const monthList = [];
      const len = resultList.length;
      const meetingLen = this.meetings.length;
      for (let i = 0; i < len; i++) {
        const temp: any = {
          displayDate: moment(resultList[i]).format('LL'),
          date: resultList[i],
          events: [],
          dateNumber: moment(resultList[i]).date()
        };

        for (let j = 0; j < meetingLen; j++) {
          const meetingDate = moment(temp.date).format(this.globalConstants.format.date);
          const meetingStartDate = moment(this.meetings[j].start).format(this.globalConstants.format.date);
          const meetingEndDate = moment(this.meetings[j].end).format(this.globalConstants.format.date);
          if (meetingDate === meetingStartDate) {
            temp.events.push(this.meetings[j]);
          } else if (meetingDate > meetingStartDate && meetingDate < meetingEndDate) {
            temp.events.push(this.meetings[j]);
          }

        }
        monthList.push(temp);
      }

      this.listSchedulerEvents = monthList.sort((a: any, b: any) => {
        return a.date.toDate().getTime() - b.date.toDate().getTime();
      });

      this.jumpToCurrentDayEvents();
    } else {
      this.listSchedulerEvents = [];
    }

  }

  /**
   *Angular life cycle function.
   *
   * @memberof SchedularListViewComponent
   */
  ngOnInit() {
    this.getMeeting();
  }
  ngOnChanges() {
    this.getMeeting();
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  jumpToCurrentDayEvents () {
    const todayDate: Number = Number(moment(this.schedularDetails.selectedDate).date().toString());
    const header = document.getElementsByClassName('fc-custom-dateheading');
    if (header) {
      let target: any = document.getElementById(todayDate.toString());
      if (target) {
        target.scrollIntoView();
      } else {
        const len = header.length;
        for (let i = 0; i < len; i++) {
          const dateId: Number = Number(document.getElementsByClassName('fc-custom-dateheading')[i].id);
          if (dateId && dateId > todayDate) {
            target = document.getElementById(dateId.toString());
            target.scrollIntoView();
            break;
          }
        }
      }

      if (!this.schedularDetails.isMobileMode) {
        const topOfPage = document.getElementById('top-of-page');
        topOfPage?.scroll(0, 0);
      }
    }
  }
}
